import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useBasicStore } from '../../../stores/basic';
import { Message } from 'element-ui';
import SvgIcon from '../common/SvgIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const basicStore = useBasicStore();

const groupNumber = '592465424';
const email = 'tylerding@tencent.com';

function onCopy(value: string | number) {
  navigator.clipboard.writeText(`${value}`);
  Message({
    message: '复制成功',
    type: 'success',
  });
}

return { __sfc: true,basicStore, groupNumber, email, onCopy, SvgIcon }
}

})